import { SignInEmailStart } from '@/components/auth/SignInEmailStart';
import { useSession } from '@/lib/auth-client';

interface VipSignInBannerProps {
  redirectTo: string;
}

export function VipSignInBanner({ redirectTo }: VipSignInBannerProps) {
  const { data: userSession } = useSession();

  if (userSession?.user) return null;

  return (
    <div className="mb-4 rounded-2xl border border-orange-200 bg-gradient-to-r from-orange-50 via-amber-50 to-orange-50 px-4 py-4 sm:px-6 sm:py-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-5">
        <div className="shrink-0">
          <p className="text-sm font-semibold text-orange-700">Sign in for VIP early access</p>
        </div>
        <div className="w-full sm:flex-1">
          <SignInEmailStart buttonLabel="Sign In" redirectTo={redirectTo} />
        </div>
      </div>
    </div>
  );
}
